import React from "react";
import clsx from "clsx";
import RateBuilderErrors from "../RateBuilderErrors";
import AddButtonNew from "../../AddButton/AddButtonNew";
import BillingPolicyBuilder from "../../BillingPolicyBuilder/BillingPolicyBuilder";
import ObjectHelper from "../../ObjectHelper/ObjectHelper";

class RateBuilderBillingPolicy extends React.Component {

  constructor(props) {
    super(props)

    this.onAddBillingPolicy = this.onAddBillingPolicy.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onRemoveBillingPolicy = this.onRemoveBillingPolicy.bind(this)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'billing_policy',
      'tab-pane': true
    })

    return (
      <div className={tabClasses} id="billing_policy">
        { this.renderErrors() }
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default" style={{marginBottom: 0}}>
              <div className="panel-heading flexed add-button-pannel">
                <div className="col-md-6" >
                  <h3 className="panel-title">
                  {`${I18n.t('billing_policy')}*`} <span className="ss-help help" title={I18n.t('billing_policy_helper_text')}></span>
                  </h3>
                </div>
                {this.renderAddButton()}
              </div>
              <div className="panel-body container">
                {this.renderBillingPolicy()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderAddButton() {
    if (!this.props.billing_policy) {
      return (
        <div className="col-md-6 content-right flexed">
          <AddButtonNew
            model="BillingPolicy" 
            ids={this.props.billing_policy ? [this.props.billing_policy.id] : null} 
            onAdd={this.onAddBillingPolicy} 
            text={I18n.t('add')} 
            buttonClasses="btn btn-secondary" 
            generalPosition="left"
          />
        </div>
      )
    }
  }

  renderBillingPolicy() {
    if (this.props.billing_policy) {
      return (
        <div>
          <div className="content-right flexed" style={{marginBottom: 15}}>
            <button type="button" className="btn btn-secondary" onClick={this.onRemoveBillingPolicy}>{I18n.t('remove')}</button>
          </div>
          <BillingPolicyBuilder onChange={this.onChange} {...this.props.billing_policy} nested={true} errors={this.prepErrors()} read_only={this.props.billing_policy && (this.props.billing_policy.read_only || this.props.billing_policy.id[0] != '-') ? true : false} hideModalButtons={true} />
        </div>
      )
    } else {
      return (
        <div className="no-records">
          <span className="none">{I18n.t('none')}</span>
        </div>
      )
    }
  }

  renderErrors() {
    var errors = RateBuilderErrors.billing_policy(this.props.errors)

    if (errors && errors.length) {
      var idx = 0
      var errors = errors.map((error) => {
        idx = idx + 1
        return <li key={error + idx}>{error}</li>
      })

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  /**********
  * Helpers *
  ***********/

  generateId() {
    var text = "";
    var possible = "0123456789";

    for (var i = 0; i < 9; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return '-' + text
  }

  hasBillingPolicyErrors() {
    var has_errors = false
    for (var i in this.props.errors) {
      if (i == 'billing_policy' || i.indexOf('billing_policy') != -1) {
        has_errors = true
        break
      }
    }
    return has_errors
  }

  prepErrors() {
    var errors = {}

    if (this.props.errors && ObjectHelper.size(this.props.errors) > 0){
      for (var i in this.props.errors) {
        if (i.indexOf('billing_policy\.') != -1) {
          var base_field = i.split('\.')[1]
          errors[base_field] = this.props.errors[i]
        }
      }
    }

    return errors
  }

  /*****************
  * Event Handlers *
  ******************/

  onAddBillingPolicy(billing_policy) {
    if (billing_policy && billing_policy.id) {
      billing_policy.read_only = true
    } else {
      billing_policy = {id: this.generateId()}
    }

    this.props.onChange({target: {
      name: 'billing_policy',
      value: billing_policy
    }})
  }

  onRemoveBillingPolicy() {
    this.props.onChange({target: {
      name: 'billing_policy',
      value: null
    }})
  }

  onChange(billing_policy) {
    this.props.onChange({target: {
      name: 'billing_policy',
      value: billing_policy
    }})
  }

}

export default RateBuilderBillingPolicy
